import { render, staticRenderFns } from "./ProjectPublicityList.vue?vue&type=template&id=6d2dbc1e&scoped=true&"
import script from "./ProjectPublicityList.vue?vue&type=script&lang=js&"
export * from "./ProjectPublicityList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPublicityList.vue?vue&type=style&index=0&id=6d2dbc1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2dbc1e",
  null
  
)

export default component.exports